module.exports = __webpack_public_path__ + "static/about-560c736e901f2cbbf4da1892c8309939.jpg";